import classNames from "classnames"
import React from "react"
import Recaptcha from "react-google-recaptcha"

import s from "./Form.module.scss"

const API_KEY = "6LfxatcUAAAAAOq0xZm0HOr1LP-7tyvdzbaq8qpH"

export default function Captcha({
  className,
  errorMessage,
  langCode,
  onChange,
}) {
  return (
    <div
      className={classNames(s.formField, s.captcha, className, {
        [s.error]: errorMessage,
      })}
    >
      <Recaptcha hl={langCode} onChange={onChange} sitekey={API_KEY} />
      {errorMessage ? (
        <div className={s.centeredErrorHolder}>
          <span className={s.errorLabel}>{errorMessage}</span>
        </div>
      ) : null}
    </div>
  )
}
